import { navigationRouteShortcuts } from './navigationShortcuts';

const keyboardShortcuts = [
    {
        title: 'General',
        shortcuts: [
            {
                description: 'Open Command Palette',
                shortcut: ['⌘ K'],
            },
            {
                description: 'Go to Search',
                shortcut: [navigationRouteShortcuts.search.displayShortcut],
            },
            {
                description: 'Zen Mode',
                shortcut: ['⇧ Z'],
            },
            {
                description: 'Back',
                shortcut: ['Esc'],
            },
            {
                description: 'Clear User Preferences',
                shortcut: ['⌘ Delete'],
            },
            {
                description: 'Log Out',
                shortcut: ['⌥ ⇧ Q'],
            },
        ],
    },
    {
        title: 'Layout',
        shortcuts: [
            {
                description: 'Enable/Disable Zen Mode',
                shortcut: ['⇧ Z'],
            },
            {
                description: 'Toggle Sider',
                shortcut: ['⇧ B'],
            },
            {
                description: 'Toggle Header',
                shortcut: ['⇧ J'],
            },
        ],
    },
    {
        title: 'Navigation',
        shortcuts: [
            {
                description: 'Go to Previous Page',
                shortcut: ['⌘ ['],
            },
            {
                description: 'Go Forward a Page',
                shortcut: ['⌘ ]'],
            },
            {
                description: 'Go to Homepage',
                shortcut: [navigationRouteShortcuts.home.displayShortcut],
            },
            {
                description: 'Go to Inbox',
                shortcut: [navigationRouteShortcuts.inbox.displayShortcut],
            },
            {
                description: 'Go to Folders',
                shortcut: [navigationRouteShortcuts.folders.displayShortcut],
            },
            {
                description: 'Go to Drafts',
                shortcut: [navigationRouteShortcuts.drafts.displayShortcut],
            },
            {
                description: 'Go to Archive',
                shortcut: [navigationRouteShortcuts.archive.displayShortcut],
            },
            {
                description: 'Go to Search',
                shortcut: [navigationRouteShortcuts.search.displayShortcut],
            },
            {
                description: 'Go to Investments',
                shortcut: [navigationRouteShortcuts.investments.displayShortcut],
            },
            {
                description: 'Go to Memos',
                shortcut: [navigationRouteShortcuts.memos.displayShortcut],
            },
            {
                description: 'Go to Pipelines',
                shortcut: [navigationRouteShortcuts.pipelines.displayShortcut],
            },
            {
                description: 'Go to Dashboards',
                shortcut: [navigationRouteShortcuts.dashboards.displayShortcut],
            },
            {
                description: 'Go to Lists',
                shortcut: [navigationRouteShortcuts.lists.displayShortcut],
            },
            {
                description: 'Go to Tasks',
                shortcut: [navigationRouteShortcuts.tasks.displayShortcut],
            },
            {
                description: 'Go to Teams',
                shortcut: [navigationRouteShortcuts.teams.displayShortcut],
            },
            {
                description: 'Go to Settings',
                shortcut: [navigationRouteShortcuts.settings.displayShortcut],
            },
            {
                description: 'Go to Trash',
                shortcut: [navigationRouteShortcuts.trash.displayShortcut],
            },
        ],
    },
    {
        title: 'Investments',
        shortcuts: [
            // {
            //     description: 'Go to Investments',
            //     shortcut: ['G', 'I'],
            // },
            // {
            //     description: 'Create an Investment',
            //     shortcut: ['G', 'I'],
            // },
            {
                description: 'Change Tabs',
                shortcut: ['⌥ + ← or →'],
            },
            // {
            //     description: 'Save into Version History',
            //     shortcut: ['G', 'I'],
            // },
            // {
            //     description: 'Peek into Investment (Hover and Hold)',
            //     shortcut: ['Space'],
            // },
            {
                description: 'Undo',
                shortcut: ['⌘ Z'],
            },
            {
                description: 'Redo',
                shortcut: ['⇧ ⌘ Z'],
            },
            // {
            //     description: 'Lock/Unlock Row/Column',
            //     shortcut: ['⇧ ⌘ L'],
            // },
            // {
            //     description: 'Group Selection',
            //     shortcut: ['⌘', 'G'],
            // },
            // {
            //     description: 'Export',
            //     shortcut: ['⇧', '⌘', 'E'],
            // },
        ],
    },
    {
        title: 'Teams',
        shortcuts: [
            {
                description: 'Change Tabs',
                shortcut: ['⌥ + ← or →'],
            },
        ],
    },
];

export default keyboardShortcuts;
